import { Link } from "react-router-dom";
import { ObjectUtils } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../reducers";
import { DescriptionComponent } from "../../components/Form";
import { CoverageConfigConstants, isMobileDevice } from "../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

export const CoverageListComponent = (props: any) => {
  const contentFooter = useSelector((state: RootState) => state.common.contentFooter);
  const footerContent = contentFooter?.contentResource?.contents;
  const lblNewTab = ObjectUtils.extractLabelFromObject(footerContent || {}, "lblNewTab");
  const { reviewPastCoverage, pageTitle } = props;
  const dispatch = useDispatch();
  const resetReviewCoverage = () => {
    dispatch({
      type: CoverageConfigConstants.REVIEW_PAST_COVERAGE,
      payload: null
    });
  }
  return (
    <>
      <DescriptionComponent level="2" heading={pageTitle} />
      {reviewPastCoverage?.map((item: any, index: number) => {
        return (
          <div
            key={index}
            className={`row justify-content-between align-items-center border-top py-2 py-md-3 m-0 coverageitem clickbtn`}
          >
            <div className={`col-12 col-sm-auto p-0 pr-sm-3`}>
              <Link
                onClick={resetReviewCoverage}
                to={{
                  pathname: "/coverage",
                  search: "?dateString=" + item.dateString
                }}
                target={isMobileDevice ? "" : "blank"}
                aria-label={!isMobileDevice ? pageTitle + " " + lblNewTab.textToRead : ""}
                className={`report-text-type-1 m-0 p-0`}
              >
                <span dangerouslySetInnerHTML={{ __html: item.display }} />
                <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
              </Link>
            </div>
          </div>
        );
      })}
      <div className={`mt-3`}></div>
    </>
  );
};

export default CoverageListComponent;
